import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {UIError} from 'common/interfaces';
import {ProfileState, IUserProfile} from 'common/interfaces/iprofile';
import { shallowCopy } from 'common/utils';

const initialProfileState: ProfileState = {
  loading: false,
  error: null,
  userProfile: null,
} as ProfileState;

const reducers = {
  setLoading: (state: ProfileState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: ProfileState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: ProfileState) => {
    state = initialProfileState;
  },

  setUserProfile: (
    state: ProfileState,
    action: PayloadAction<IUserProfile | null>,
  ) => {
    console.log('Setting user profile in redux.....', action.payload);
    state.userProfile = action.payload;
  },
  updateUserProfile: (
    state: ProfileState,
    action: PayloadAction<IUserProfile | null>,
  ) => {
    shallowCopy(state.userProfile, action.payload);
  },
};

const profileSlice = createSlice({
  name: 'profileState',
  initialState: initialProfileState,
  reducers: reducers,
});

export default profileSlice.reducer;
export const ProfileActions = profileSlice.actions;
